// extracted by mini-css-extract-plugin
module.exports = {"root":"Login_root__cxDvD","form_wrap":"Login_form_wrap__BuqwP"};